module.exports = __webpack_public_path__ + "media/photo/it-management-d3369aff.jpg";